import {PriceInput, tfPriceInput} from "./input/PriceInputComponent";
import {priceFormat, PriceFormat} from "./input/PriceFormat";
import {priceStep, PriceStep} from "./input/PriceStep";
import {PriceStrategyService} from "./service/PriceStrategyService";
import {priceStrategyValueFilter, PriceStrategyValueFilter} from "./filter/PriceStrategyValueFormatFilter";
import {priceStrategyStrike, PriceStrategyStrike} from "./filter/PriceStrategyStrikePipe";
import {
    PriceStrategyValuePrecisionFilter,
    priceStrategyValuePrecisionFilter
} from "./filter/PriceStrategyValueFormatPrecisionFilter";

export default angular.module("tfApp.components.inputs.price", [])
                      .component(PriceInput, tfPriceInput())
                      .service(PriceStrategyService.id, PriceStrategyService)
                      .directive(PriceFormat, priceFormat)
                      .directive(PriceStep, priceStep)
                      .filter(PriceStrategyValueFilter, priceStrategyValueFilter)
                      .filter(PriceStrategyStrike, priceStrategyStrike)
                      .filter(PriceStrategyValuePrecisionFilter, priceStrategyValuePrecisionFilter)
                      .name;
